/* DEPRECATED */

import { useTranslation } from 'react-i18next'
import styles from './RecaptchaDisclaimer.module.scss'

export const RecaptchaDisclaimer = () => {
  const { t } = useTranslation()

  return (
    <span className={styles['container']}>
      {t('main.recaptcha.disclaimer')}
      <a className={styles['link']} href='https://policies.google.com/privacy'>
        {t('main.recaptcha.privacy_policy')}
      </a>
      {t('main.recaptcha.and')}
      <a className={styles['link']} href='https://policies.google.com/terms'>
        {t('main.recaptcha.terms')}
      </a>
      {t('main.recaptcha.apply')}.
    </span>
  )
}
